<template>
    <div class="share-tips" @click="componentData.visible = false"></div>
</template>

<script>
export default {
    inject: ['reload'],
    props: ['componentData'],
    data() {
        return {}
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {}
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
.share-tips {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .85) url('../assets/img/wechat-tips.png') no-repeat 50% 5vh;
    background-size: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
}
</style>